import { type PaymentKeyHash, type StakeKeyHash } from '@lucid-evolution/lucid';
import 'reflect-metadata';
import { asEntity } from '../Commons/Decorators/Decorator.asEntity';
import { Convertible } from '../Commons/Decorators/Decorator.Convertible';
import { BaseEntity } from './Base/Base.Entity';

//FIXME no puede derivar normal Entity por que normal Entity usa WalletEntity para controlar y se arma dependencia circular

@asEntity()
export class WalletEntity extends BaseEntity {
    protected static _apiRoute: string = 'wallets';
    protected static _className: string = 'Wallets';

    // #region fields

    @Convertible()
    walletName!: string;

    @Convertible()
    walletValidatedWithSignedToken!: boolean;

    @Convertible()
    paymentPKH!: PaymentKeyHash;

    @Convertible()
    stakePKH!: StakeKeyHash;

    @Convertible()
    name!: string;

    @Convertible()
    email!: string;

    @Convertible()
    isCoreTeam!: boolean;

    @Convertible()
    testnet_address!: string;

    @Convertible()
    mainnet_address!: string;

    @Convertible()
    createdBy!: string;

    @Convertible()
    lastConnection!: Date;

    @Convertible({ isCreatedAt: true })
    createdAt!: Date;

    @Convertible({ isUpdatedAt: true })
    updatedAt!: Date;

    // #endregion fields
}
